<template>
	<div class="goods-form-wrapper refModal"
		 :style="[forContragent ? {'padding-bottom': '0px', 'min-height': 'unset'} : {}]">
		<div class="header-sidebar mb-4" slot="header" v-if="!forContragent">
			<h4 class="pull-left">
				{{ $t('incomes.block-counteragent.title') }}
			</h4>
			<b-button class="pull-right close-btn" @click="close" type="button" variant="link"><i
				class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
			<hr>
		</div>
		<p v-if="contragentNotFilled" style="color: red;">{{$t('please-title')}}</p>
		<form>
			<b-form-group
				breakpoint="lg"
				label-size="sm"
				label-cols="4"
				:label="$t('incomes.block-unit.name')"
				label-for="refName"
				class="required"

			>
				<b-form-input :required="true"
							  size="sm"
							  id="fullName"
							  ref="fullName"
							  v-model="item.fullName"
							  :placeholder="$t('incomes.block-unit.name')"/>
			</b-form-group>
			<b-form-group
				breakpoint="lg"
				label-size="sm"
				label-cols="4"
				:label="$t('promo-to-product.department')"
				label-for="refName"
				class="certificate-list"

			>
				<multiselect
					v-model="item.departments"
					:options="wholesaleDepartments"
					:multiple="true"
					track-by="id"
					:show-labels="false"
					:allow-empty="true"
					label="name"
					:placeholder="$t('promo-to-product.department')"
					class="multiselect-pricing"
				>
				</multiselect>
			</b-form-group>
			<!--<b-form-group
				breakpoint="lg"
				label-size="sm"
				label-cols="4"
				:label="$t('contragent.short-name')"
				label-for="refName"
				class="required"

			>
				<b-form-input :required="true"
							  size="sm"
							  id="shortname"
							  v-model="item.shortName"
							  :placeholder="$t('contragent.short-name')"/>
			</b-form-group>
			<b-form-group
				v-if="false"
				breakpoint="lg"
				label-size="sm"
				label-cols="4"
				:label="$t('Email')"
				label-for="refName"

			>
				<b-form-input size="sm"
							  id="email"
							  v-model="item.email"
							  :placeholder="$t('Email')"/>
			</b-form-group>-->

			<b-form-group
				breakpoint="lg"
				label-size="sm"
				label-cols="4"
				:label="$t('contragent.phone')"
				label-for="refName"

			>
				<b-form-input size="sm"
							  id="phone"
							  v-model="item.phone"
							  :placeholder="$t('contragent.phone')"/>
			</b-form-group>

			<b-form-group
				breakpoint="lg"
				label-size="sm"
				label-cols="4"
				:label="$t('contragent.address')"
				label-for="refName"

			>
				<b-form-input size="sm"
							  id="address"
							  v-model="item.address"
							  :placeholder="$t('contragent.address')"/>
			</b-form-group>

			<b-form-group
				breakpoint="lg"
				label-size="sm"
				label-cols="4"
				label="ИНН"
				label-for="inn"

			>
				<b-form-input size="sm"
							  id="inn"
							  v-model="item.inn"
							  placeholder="ИНН"/>
			</b-form-group>

			<b-form-group
				breakpoint="lg"
				label-size="sm"
				label-cols="4"
				label="ОКОНХ"
				label-for="okonx"
			>
				<b-form-input size="sm"
							  id="okonx"
							  v-model="item.okonx"
							  placeholder="ОКОНХ"/>
			</b-form-group>
			<b-form-group
				breakpoint="lg"
				label-size="sm"
				label-cols="4"
				:label="$t('contragent.bank')"
				label-for="okonx"
			>
				<b-form-input size="sm"
							  id="bank"
							  v-model="item.bankAccount"
							  :placeholder="$t('contragent.bank')"/>
			</b-form-group>
			<b-form-group
				breakpoint="lg"
				label-size="sm"
				label-cols="4"
				:label="$t('contragent.ndc')"
				label-for="okonx"
			>
				<b-form-input size="sm"
							  id="ndc"
							  v-model="item.vatAccount"
							  :placeholder="$t('contragent.ndc')"/>
			</b-form-group>

<!--			<select-or-create-->
<!--				:is-for-contragent="forContragent"-->
<!--				@showNestedModal="showNestedModal"-->
<!--				:options="getRaionulChildren.items"-->
<!--				label="Raionul"-->
<!--				:label-size="4"-->
<!--				:field-size="8"-->
<!--				:parent-name="'Raionul'"-->
<!--				:parent-code="'Raionul'"-->
<!--				v-model="dropdowns.raionul.value"-->
<!--			></select-or-create>-->

			<select-or-create
				:is-for-contragent="forContragent"
				@showNestedModal="showNestedModal"
				:options="getCategoryChildren.items"
				:label="$t('contragent.category-name')"
				:label-size="4"
				:field-size="8"
				:parent-name="'Category'"
				:parent-code="'CONTRAGENT_CATEGORY'"
				v-model="dropdowns.category.value"
			></select-or-create>

			<!--<select-or-create
				:is-for-contragent="forContragent"
				@showNestedModal="showNestedModal"
				:options="dropdowns.country.items"
				:label="$t('contragent.country-name')"
				:label-size="4"
				:field-size="8"
				:parent-name="'Country'"
				:parent-code="'CITIZEN'"
				v-model="dropdowns.country.value"
			></select-or-create>-->

			<select-or-create
				:is-for-contragent="forContragent"
				@showNestedModal="showNestedModal"
				:options="getGroupChildren.items"
				:label="$t('contragent.group-name')"
				:label-size="4"
				:field-size="8"
				:parent-name="'Group'"
				:parent-code="'contragent_groups'"
				v-model="dropdowns.group.value"
			></select-or-create>

			<b-form-group
				breakpoint="lg"
				label-size="sm"
				label-cols="4"
				:label="$t('contragent.comment')"
				label-for="refName"
			>
				<b-form-textarea
					id="comment"
					v-model="item.comment"
					:placeholder="$t('contragent.comment')"
					rows="3"
					max-rows="6"
				></b-form-textarea>
			</b-form-group>
		</form>
		<div class="model-actions">
			<b-row class="align-items-center">
				<b-col cols="12" class="mb-3 mb-xl-0">
					<b-row :class="[forContragent ? 'd-flex justify-content-end' : 'align-items-center']">
						<b-col cols="4">
							<b-button block size="sm" type="button" @click="close" variant="outline-danger">{{
								$t('actions.cancel') }}
							</b-button>
						</b-col>
						<b-col cols="4">
							<b-button block type="button" size="sm" @click="create" variant="primary">{{ $t('actions.save') }}
							</b-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {mapGetters, mapActions, mapState} from 'vuex';
	// import ReferencesService from "../../../services/references.sevice";
	// import SelectOrCreate from "../../components/SelectOrCreate";
	import Multiselect from 'vue-multiselect'
	import ContrAgentService from "../../../services/contragent.service";

	const itemInitial = {
		id: null,
		fullName: '',
		shortName: '',
		email: '',
		phone: '',
		mobile: '',
		address: '',
		inn: null,
		okonx: null,
		bankAccount:'',
		vatAccount:'',
		address2: '',
		countryId: null,
		countryName: '',
		categoryId: null,
		regionId: null,
		categoryName: '',
		groupId: null,
		groupName: '',
		comment: '',
		departmentIds: [],
		departments: []
	};

	export default {
		name: 'ContrAgentForm',

		props: {
			parentName: {},
			parentCode: {},
			forContragent: {
				type: Boolean,
				default: false
			},
			forEditing: {
				type: Boolean,
				default: false
			},
			oldData: {
				type: Object,
				default: () => itemInitial
			}
		},
		components: {
			SelectOrCreate: () => import('../../components/SelectOrCreate'),
			Multiselect
		},
		data() {
			return {
				item: Object.assign({}, itemInitial),
				contragentNotFilled: false,
				dropdowns: {
					category: {
						items: [],
						value: null
					},
					group: {
						items: [],
						value: null
					},
					country: {
						items: [],
						value: null
					},
					raionul: {
						items: [],
						value: null
					}
				}
			}

		},

		methods: {
			...mapActions('contragents', [
				'createContragentStore',
			]),
			...mapActions('references', [
				'getReferenceChildren',
			]),
			showNestedModal(type) {
				this.$emit('showNestedModal', type);
			},
			focusName() {
				this.$refs.fullName.focus();
			},
			close() {
				this.contragentNotFilled = false;
				this.item = Object.assign({}, itemInitial);
				this.$emit('close', true)
			},
			/*loadCategories() {
				ReferencesService.getReferenceChildren('CONTRAGENT_CATEGORY').then(response => {
					this.dropdowns.category.items = response.data;
				})
			},
			loadGroups() {
				ReferencesService.getReferenceChildren('contragent_groups').then(response => {
					this.dropdowns.group.items = response.data;
				});
			},*/
			async create() {
				if (this.forContragent) { // IS PARENT CONTRAGENT.VUE
					if (this.item.fullName.trim() != '') {
						// IS REQUIRED FIELDS FILLED
						this.contragentNotFilled = false;
						if (this.item.departments.length > 0) {
							this.item.departmentIds = this.item.departments.map(el => el.id);
						} else {
							this.item.departmentIds = []
						}
						await this.createContragentStore(this.item);
						if (!this.createError) {
							this.$emit('reload', true);
							this.dropdowns.group.value = null;
							this.dropdowns.category.value = null;
							this.dropdowns.country.value = null;
							this.dropdowns.raionul.value = null
						} else {
							this.$emit('reload', false);
						}
						if (!this.forEditing && !this.createError) {
							this.item = Object.assign({}, itemInitial);
							this.dropdowns.group.value = null;
							this.dropdowns.category.value = null;
							this.dropdowns.country.value = null;
							this.dropdowns.raionul.value = null
						}
					} else {
						this.contragentNotFilled = true;
					}
				} else {
					ContrAgentService.storeOrUpdate(this.item).then(response => {
						this.$emit('reload', true);
						this.$emit('close', true);
						this.$emit('value', response.data);
						this.item = Object.assign({}, itemInitial);
					})
				}
			}
		},
		computed: {
			...mapState('departments', [
				'wholesaleDepartments'
			]),
			...mapGetters('references', [
				'getRefChildren', 'getGroupChildren', 'getCategoryChildren', 'getCountryChildren',
				'getRaionulChildren'
			]),
			...mapState('contragents', [
				'createError'
			]),
		},
		async mounted() {
			/*await this.loadCategories();
			await this.loadGroups();*/
			await this.getReferenceChildren('CONTRAGENT_CATEGORY');
			await this.getReferenceChildren('contragent_groups');
			await this.getReferenceChildren('citizen');
			await this.getReferenceChildren('Raionul');
			this.dropdowns.category = this.getCategoryChildren;
			this.dropdowns.group = this.getGroupChildren;
			this.dropdowns.country = this.getCountryChildren;
			this.dropdowns.raionul = this.getRaionulChildren
			this.$emit('gotOptionsForFilter');
		},

		watch: {
			'dropdowns.category.value': {
				handler() {
					this.getCategoryChildren.items.filter((category) => {
						if (category.id === this.dropdowns.category.value) {
							this.item.categoryId = category.id;
							this.item.categoryName = category.name;
						}
						return true;
					});
				}
			},
			'dropdowns.raionul.value': {
				handler() {
					this.getRaionulChildren.items.filter((region) => {
						if (region.id === this.dropdowns.raionul.value) {
							this.item.regionId = region.id;
						}
						return true;
					});
				}
			},
			'dropdowns.group.value': {
				handler() {
					this.getGroupChildren.items.filter((category) => {
						if (category.id === this.dropdowns.group.value) {
							this.item.groupId = category.id;
							this.item.groupName = category.name;
						}
						return true;
					});
				}
			},
			'dropdowns.country.value': {
				handler() {
					this.dropdowns.country.items.filter((category) => {
						if (category.id === this.dropdowns.country.value) {
							this.item.countryId = category.id;
							this.item.countryName = category.name;
						}
						return true;
					});
				}
			},
			/*'getRefChildren': {
				handler() {
					this.loadCategories();
					this.loadGroups();
				}
			},*/
			'oldData': {
				handler () {
					this.item = Object.assign({}, this.oldData);
					if (!this.item.categoryId) {
						this.item.categoryId = null;
					}
					if (!this.item.groupId) {
						this.item.groupId = null;
					}
					if (!this.item.countryId) {
						this.item.countryId = null;
					}
					let selectedDepartments = [];
					if (this.item.departmentIds && this.item.departmentIds.length > 0) {
						this.wholesaleDepartments.forEach(dep => {
						  if(this.item.departmentIds.indexOf(dep.id) !== -1) {
							selectedDepartments.push(dep);
						  }
						});
					}
					Vue.set(this.item, "departments", selectedDepartments);
					this.dropdowns.group.value = this.item.groupId;
					this.dropdowns.category.value = this.item.categoryId;
					this.dropdowns.country.value = this.item.countryId;
					this.dropdowns.raionul.value = this.item.regionId
				}
			}
		}
	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
